import React, { useState, useContext, useRef } from 'react';
import logo from '../assets/LOGO.svg';
import Button from '../components/UI/button/Button';
import AuthInput from '../components/auth-input/AuthInput';
import arrowRightToBracket from '../assets/icons/arrow-right-to-bracket.svg';
import { AuthContext } from '../context';
import { useNavigate } from 'react-router-dom';
import credentials from '../entry-data/credentials.json';

function LoginPage() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [validationKey, setValidationKey] = useState(0);
  const [credentialsError, setCredentialsError] = useState('');
  const validationResultRef = useRef({ login: null, password: null });

  const handleSubmit = () => {
    setCredentialsError('');
    validationResultRef.current = { login: null, password: null };
    setValidationKey((prev) => prev + 1);
  };

  const handleLoginValidation = (valid, value) => {
    validationResultRef.current.login = { valid, value };
    tryCheckCredentials();
  };

  const handlePasswordValidation = (valid, value) => {
    validationResultRef.current.password = { valid, value };
    tryCheckCredentials();
  };

  const tryCheckCredentials = () => {
    const { login: loginResult, password: passwordResult } = validationResultRef.current;
    if (!loginResult || !passwordResult || !loginResult.valid || !passwordResult.valid) return;
    if (
      loginResult.value.trim() === credentials.login &&
      passwordResult.value === credentials.password
    ) {
      login(loginResult.value, passwordResult.value);
      navigate('/dashboard');
    } else {
      setCredentialsError('Пользователя нет в базе данных');
    }
  };

  return (
    <div className="App">   
      <img src={logo} alt="logo" />
      <span
        style={{
          paddingTop: '41px',
          paddingBottom: '41px',
          fontFamily: 'var(--semibold-text-font-family)',
          color: 'var(--tokens-colors-text-basic)',
          fontSize: 'var(--info-text-font-size)',
          fontWeight: 'var(--bottom-tab-lable-font-weight)',
        }}
      >
        Войдите в свою учетную запись
      </span>
      <AuthInput
        text='Логин'
        type='text'
        placeholder='Email / Phone'
        validationKey={validationKey}
        credentialsError={credentialsError}
        onValidationComplete={handleLoginValidation}
        onLoginChange={() => setCredentialsError('')}
      />
      <AuthInput
        text='Пароль'
        type='password'
        placeholder='••••••'
        validationKey={validationKey}
        onValidationComplete={handlePasswordValidation}
        onPasswordChange={() => setCredentialsError('')}
      />
      <Button onClick={handleSubmit}>
        <img src={arrowRightToBracket} alt="arrow-right-to-bracket" />
        Войти
      </Button>
    </div>
  );
}

export default LoginPage;
